<template>
    <span class="vrm-form__error">
        <span class="sg-input-error">
            {{
                $t('form.required', {
                    i18nFallback: 'This field is required',
                })
            }}
        </span>
    </span>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('form')
export default class InputError extends Vue {}
</script>
